<template>
  <div>
      <section class="section-shaped my-0">
          <div class="shape shape-skew">
              <img src="/img/bkgrnd.jpg" class="img-fluid">
          </div>

            <div class="d-none d-lg-block container shape-container">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12">
                          <img src="/img/devconf_logo_white_poly.png" width="100%">
                          <center class="heading">Developer Info</center>
                        </div>
                    </div>
                </div>
            </div>

      </section>

      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-12">
                            <card class="border-0" shadow body-classes="py-5">
                              <h4><i>Waarom een nieuw design?</i></h4>
                              <p>De hoofdreden is dat we een nieuwe infrastructuur hebben, vooreen gebruikten we een "Single Node Docker Cluster"
                                wat twee keer geleid heeft tot een downtime van ~45 minuten. In de context van vorig jaar waar de inschrijf applicatie
                              met het moto "Because we can" was opgezet konden we ons deze downtime veroorloven. Mochten we dit jaar opteren voor een
                              digitaal event wil ik ervoor zorgen dat onze infra klaar is voor maximale robuustheid en elasticiteit tegen de laagste kosten.</p>
                              <p>
                                Als we een spreker te kort komen kan ik hier wel een praatje over maken :)
                                <br><base-button outline type="default" @click="abstract = true">
                                    "abstract"
                                </base-button>
                              </p>
                              <h4><i>Content delivery network</i></h4>
                              <p>Om meer garanties te kunnen doen met betrekking tot beschikbaarheid heeft onze nieuwe infrastructuur
                              een CDN als core.</p>
                              <div class="row">
                                <div class="col-lg-1"></div>
                                <div class="col-lg-8">
                                  <blockquote class="blockquote">
                                    <p class="mb-0">Een content delivery network (CDN, ook content distribution network)
                                      is een netwerk van proxyservers die geografisch verspreid zijn over het internet in
                                      verschillende datacenters, zodat gebruikers snel en zonder vertraging content kunnen
                                      binnenhalen. Dit kan gaan om zowel teksten, documenten, figuren, media, mediastreams,
                                      scripten, als applicaties.</p>
                                    <footer class="blockquote-footer">Wikipedia</footer>
                                  </blockquote>
                                </div>
                              </div>
                              <p>Wij maken gebruik van het gehoste CDN van AWS hierna cloudfront genoemd, cloudfront bestaat uit 200+ edge locaties
                              verspreid over de hele wereld.</p>
                              <center>
                                <img src="https://media.amazonwebservices.com/blog/2019/cf_map_2019_2.png" width="60%" />
                              </center>
                              <h4><i>Development Pipelines</i></h4>
                              <p>Om het live brengen van onze website verder te streamlinen is er een buildpipeline binnen AWS opgezet die
                              na een commit het VUE.js project build*. Deze wordt dan automatisch naar S3 gedistribueerd.</p>
                              <p>S3 staat voor Simple Storage Service en fungeerd in onze topologie als origin van de static resources,
                                met andere woorden cloudfront haalt hier zijn origineel op wanneer er een cache mis optreed.</p>
                              <p>
                              <p>We hebben 2 pipelines ingericht: (<a href="https://bitbucket.org/bohanssen/devconf.nl/branches/?status=all" target="_blank">repository</a>)</p>
                              <center>
                                <div class="col-md-8 table-responsive">
                                  <table class="table table-striped">
                                    <thead>
                                      <tr>
                                        <th></th>
                                        <th>Staging</th>
                                        <th>Production</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <th>Branch</th>
                                        <td>Staging</td>
                                        <td>Master</td>
                                      </tr>
                                      <tr>
                                        <th>Hostname</th>
                                        <td><a href="https://staging.devconf.nl" target="_blank">staging.devconf.nl</a></td>
                                        <td><a href="https://dsqc6m6kf7x1k.cloudfront.net" target="_blank">dsqc6m6kf7x1k.cloudfront.net</a><br>
                                        <small>Ik zet het DNS record om zodra we akkoord zijn met het nieuwe design.</small></td>
                                      </tr>
                                      <tr>
                                        <th>Cache TTL</th>
                                        <td>1 minuut</td>
                                        <td>24 uur</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </center>
                              <small>* Daarom hebben we een nieuw design,
                                ik had een node achtig project nodig voor m'n pipeline en ik kan toevallig met VUE overweg.
                                En voor het design ben ik afhankelijk van in hoevere ik een gratis template verbouwd krijg &#128517;</small>
                              <hr>
                              <h4><i>What about the backend?</i></h4>
                              <p>Op het moment bestaat de site alleen als static resource, alles wat server interactie vergt zoals
                              video streams en live chat besteden we op dit moment uit aan Youtube. Ik zal alvast navragen bij
                              netwerk en security of dit vanaf het APG netwerk kan/mag.</p>
                              <p>Experimenten met de Media Live services van AWS waren succesvol maar relatief prijzig (&euro;15,-)
                                voor 3 uurtjes "aankloemelen" om de latency omlaag te brengen. Daar tegenover vind ik Youtube een
                                acceptabel alternatief.</p>
                              <h5><i>AWS Lambda etc</i></h5>
                              <p>Tijdens de quarantaine heb ik om mezelf te vermaken flink geexperimenteerd met de Serverless services van AWS, denk hierbij aan:
                                <ul>
                                  <li>Lambda (FAAS)</li>
                                  <li>Step Functions (Statemachines)</li>
                                  <li>Simple Queue Service</li>
                                  <li>API Gateway</li>
                                  <li>Cognito (User Management)</li>
                                  <li>DynamoDB (pay as you go database)</li>
                                  <li>Cloudformation (Infra as code)</li>
                                </ul>
                                Als we behoefte hebben aan backend functionaliteit stel ik voor om van deze stack gebruik te maken,
                                hiermee nemen we afscheid van onze docker infra structuur en gaan we serverless om robuustheid, elasticiteit en
                                lage kosten te garanderen.
                              </p>
                              <h5><i>Draftsman.io</i></h5>
                              <p>Tijdens de serverless experimenten heb ik een eerste versie opgezet van een code generator, het idee achter deze generator is
                              dat je met behulp van json je domein kunt beschrijven (domein/subdomein/aggregate/commando/event) en dat de generator dit omzet in
                              de benodigde NodeJS code en Cloudformation om er een Event driven en event sourced applicatie van te maken gestoeld op de CQRS principes.</p>
                              <center>
                                <table class="table col-lg-4">
                                  <thead>
                                    <tr>
                                      <th>Input</th>
                                      <th>Generator</th>
                                      <th>Output</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>JSON<br>BPMN<br>DMN</td>
                                      <td><img src="img/generator.png" /></td>
                                      <td>Javascript (NodeJS)<br>YAML (Cloudformation)<br>Amazon State Language</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </center>
                              <p>Verre van feature complete, maar wellicht net genoeg om development te versnellen. Het gegenereerde project hanteerd dan de volgende structuur:</p>
                              <img src="img/CQRS.png" width="100%" />
                              <hr>
                              <h4><i>Wat korte info video's over de genoemde services</i></h4>
                              <div class="embed-responsive embed-responsive-16by9">
                                <iframe class="embed-responsive-item"
                                  src="https://www.youtube.com/embed/videoseries?list=PLr4R0prf3HbH_aKjifWNNDimzgZdOaqSK"
                                  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                  allowfullscreen></iframe>
                              </div>
                            </card>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </section>

      <!-- Abstract -->
      <modal :show.sync="abstract">
       <template slot="header">
          <h5 class="modal-title">devConf: Road to Serverless</h5>
       </template>
       <div>
         <p>
           Het organiseren van een conferentie, hoe klein het begin ook is, brengt uitdagingen met zich mee waar je
           op voorhand niet aan denkt of waar je als developer zijnde in iedergeval niet aan denkt. Maar wanneer je
           voor het eerst een conferentie organiseert dan leer je vanzelf over bijvoorbeeld zaal indeling &amp; communicatie.
           Andere zaken komen naar boven in een evaluatie, bijvoorbeeld dat onze programmering en met name de tijdsindeling
           beter kan.
         </p>
         <p>
           En zo ging het voor ons, in december vorig jaar hadden we onze retrospective en daarna zaten we vol nieuwe ideeën
           hoe onze tweede editie nog beter en belangrijk breder ingestoken kan worden.
         </p>
         <p>
           Vol goede moed verzamelde we alle kennis die we opgedaan hadden en was ons draaiboek in januari dan ook klaar om
           uitgevoerd te worden. In februari legde we de zaal en budgettering vast en in maart werd duidelijk dat het jaar
           tweeduizend twintig anders ging verlopen dan dat we gewend waren.
         </p>
         <p>
           Maar november was nog ver weg, dus we gingen door, en toen we in augustus begonnen met het opstellen van het
           programma zweefde de vraag “ik weet niet of we in november met zoveel mensen bij elkaar willen komen” nog steeds
           boven ons hoofd. En we begonnen met nadenken over virtuele alternatieven.
         </p>
         <p>
           Vorig jaar heb ik mogen spreken over Design for Failure en de take away in deze talk was “Het ligt aan je context
           hoe ver je moet gaan om uptime te garanderen”
         </p>
         <p>
           Vorig jaar was onze website een ondersteunende applicatie met de redenering “because we can” het registratie proces
           liep via de website maar we hadden de mogelijkheid om terug te vallen op papier als de server zou crashen om wat
           voor een reden dan ook. In deze context is een “singel node docker cluster” prima te beargumenteren,
           puur omdat we de kosten laag willen houden.
         </p>
         <p>
           En ja, de website heeft vorig jaar 2x 45 minuten eruit gelegen omdat onze cloud-provider problemen had in het
           datacenter in Amsterdam. Maar wanneer jou evenement digitaal wordt, dan verandert de context van de website
           180 graden. De website is mission critical, de backbone van het evenement en failure is altijd een optie.
         </p>
         <p>
           devConf is een gratis evenement, en dat willen we zo houden. De vraag is dan, hoe garandeer ik uptime zonder
           hiervoor de hoofdprijs te betalen. Het antwoord is <i>omdenken</i>: Let’s go serverless!
         </p>
         <hr>
         <p>
           Meer een intro dan een abstract maar in feite gaat het over het refactoren
           van de devconf website en de cloud architectuur keuzes die daarbij gemaakt worden.
         </p>
       </div>
     </modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
export default {
  components: {
    Modal
  },
  data(){
    return {
      abstract: false
    }
  }
}
</script>
